import React, { useEffect, useMemo } from 'react';
import PCConsoleTopCharts from '@intelligence/pages/TopCharts/PCConsoleGames/PCConsoleTopCharts';
import {
  TopchartPageId,
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { getCascaderMetricsOptionsAndValue } from '@/pages/intelligence/pages/TopCharts/PCGames/MetricsTable/utils';
import { PCConsoleDataBrainSegementList } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { getPCConsoleMetricValues, getDeviceValuesByPageId } from '@intelligence/pages/TopCharts/PCGames/_config/utils';
import { defaultMetrictableApiParams } from '@intelligence/pages/TopCharts/PCGames/MetricsTable/utils/constant';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const PCConsoleDataBrainCalibration: React.FC = () => {
  const entityType = PC_CONSOLE_COMBINE_ENTITY_TYPE;
  const pageId = TopchartPageId.PCConsoleDataBrainCalibration;
  const businessType = 'databrain-calibration-pc-console-topCharts';
  const downloadKey = 'databrainCalibrationPCConsoleTopCharts';
  const hasUrlShortLink = false;
  const downloadLogConfigKey = `${entityType}_${pageId}_TopChartsMetricsTableDownload`;
  const downloadBtnLogConfigKey = `${entityType}_${pageId}_TopChartsMetricsTableDownloadBtn`;
  const jumpQuery = { isFromDataBrainCalibrationTopCharts: true };

  const { pcConsoleCascaderMetricsOptions, pcConsoleCascaderMetricsMap, pcConsoleDefaultMetrics } =
    PCConsoleDataBrainSegementList;

  const deviceCur = useMemo(() => getDeviceValuesByPageId(pageId, entityType), [pageId, entityType]);

  const tableColumnsListCur = useMemo(() => {
    const mappedList = pcConsoleDefaultMetrics
      .map((item) => pcConsoleCascaderMetricsMap?.[item])
      .filter((metric: any) => metric && metric?.value);

    if (mappedList.length) {
      return mappedList;
    }

    return pcConsoleDefaultMetrics.map((item) => ({
      value: item,
      dataSource: 'databrain',
      metricValue: 'databrain',
      text: 'dbi_metric_total_revenue',
    }));
  }, [pcConsoleDefaultMetrics, pcConsoleCascaderMetricsMap]);

  const defaultParamsCur = useMemo(() => {
    const orderMetricsParams = getPCConsoleMetricValues(tableColumnsListCur);
    return {
      ...defaultMetrictableApiParams,
      entity_type: entityType,
      order_metric: orderMetricsParams?.order_metric,
      order_source: orderMetricsParams?.order_source,
      source_metrics: orderMetricsParams?.source_metrics,
      topchart_name: '',
      region_type: 'market',
      regions: ['global'],
      date_type: 'daily',
      device: deviceCur,
      b_data_brain: 1,
      b_true_data: true,
    } as any;
  }, [tableColumnsListCur, entityType, deviceCur]);

  const { options: initialMetricSelectorOptionsTemp, value: initialMetricSelectorValues } =
    getCascaderMetricsOptionsAndValue(
      pageId,
      pcConsoleCascaderMetricsOptions,
      pcConsoleDefaultMetrics,
      defaultParamsCur,
    );

  const initialMetricSelectorOptions = useMemo(
    () => initialMetricSelectorOptionsTemp,
    [initialMetricSelectorOptionsTemp],
  );

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.combileMetricTable?.type,
    isUseCond: true,
  });

  useEffect(() => {
    buriedPointPage(dbiPageLogMes.topChartsPCConsoleGamesDataBrainCalibration);
  }, []);

  if (!Array.isArray(pcConsoleCascaderMetricsOptions) || !pcConsoleCascaderMetricsMap) {
    return null;
  }

  return (
    <>
      <MarqueeBanner />
      <PCConsoleTopCharts
        entityType={entityType}
      pageId={pageId}
      businessType={businessType}
      downloadKey={downloadKey}
      downloadLogConfigKey={downloadLogConfigKey}
      downloadBtnLogConfigKey={downloadBtnLogConfigKey}
      hasUrlShortLink={hasUrlShortLink}
      initialMetricSelectorValues={initialMetricSelectorValues}
      initialMetricSelectorOptions={initialMetricSelectorOptions}
      pcConsoleCascaderMetricsMap={pcConsoleCascaderMetricsMap}
      pcConsoleCascaderMetricsOptions={pcConsoleCascaderMetricsOptions}
      pcConsoleDefaultMetrics={pcConsoleDefaultMetrics}
      tableColumnsListCur={tableColumnsListCur}
      // 校准页仅展示 DataBrain 指标，因此不需要自动追加 Metacritic/Steam 静态列
      appendCombineExtras={false}
      rangeTimeComponentDefault={latestTimeTypeHasData}
      defaultParams={defaultParamsCur}
      firstDownLoadBubleShow={false}
      pageLogKey="topChartsPCConsoleGamesDataBrainCalibration"
      pageLogInfo={dbiPageLogMes.topChartsPCConsoleGamesDataBrainCalibration}
      jumpQuery={jumpQuery}
    />
    </>
  );
};

export default PCConsoleDataBrainCalibration;
